import React, { useEffect, useState, useRef } from "react";
import DashSideBar from "../../shared/DashSideBar";
import axios from "axios";
import "./HomePage.css";
import { Toast } from "primereact/toast";
import ListContents from "../../Components/HomePage/ListContent/ListContent";
import HomeReels from "../../Components/HomePage/HomeReels/HomeReels";
import HomeClients from "../../Components/HomePage/HomeClients/HomeClients";

function HomePage() {
  const toast = useRef(null);
  const [formData, setFormData] = useState({
    id: 0,
    medicalMachineSupplied: "",
    hospitalsClinicsEquipped: "",
    yearsOfExperience: "",
    customerSupport: "",
  });

  const isFetched = useRef(false);

  const getHomePageData = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/HomePages/HomePageResponseDashboard"
      );

      if (response.data) {
        setFormData(response.data);
      }
    } catch (error) {
      console.error("Error fetching homepage data:", error);
    }
  };

  const updateHomePageData = async () => {
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_URL + `api/HomePages/${formData.id}`,
        formData
      );

      if (response.status === 204 || response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Homepage data updated successfully!",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating homepage data:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update homepage data.",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    if (!isFetched.current) {
      getHomePageData();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9 p-4">
        <Toast ref={toast} />
        <div className="form-group mb-3">
          <label>Medical Machines Supplied</label>
          <input
            type="text"
            className="form-control"
            name="medicalMachineSupplied"
            value={formData.medicalMachineSupplied}
            onChange={handleChange}
          />
        </div>

        <div className="form-group mb-3">
          <label>Hospitals & Clinics Equipped</label>
          <input
            type="text"
            className="form-control"
            name="hospitalsClinicsEquipped"
            value={formData.hospitalsClinicsEquipped}
            onChange={handleChange}
          />
        </div>

        <div className="form-group mb-3">
          <label>Years of Experience</label>
          <input
            type="text"
            className="form-control"
            name="yearsOfExperience"
            value={formData.yearsOfExperience}
            onChange={handleChange}
          />
        </div>

        <div className="form-group mb-3">
          <label>Customer Support</label>
          <input
            type="text"
            className="form-control"
            name="customerSupport"
            value={formData.customerSupport}
            onChange={handleChange}
          />
        </div>

        <button
          className="btn btn-primary homepagesavebutton"
          style={{ backgroundColor: "rgb(42, 76, 78)" }}
          onClick={updateHomePageData}
        >
          Save
        </button>

        <ListContents />
        <HomeReels />
        <HomeClients />
      </div>
    </div>
  );
}

export default HomePage;
